const Images = {
  LOGO: require("./../img/logo.png").default,
};

export default Images;
